/**
 * Application initialize file.
 *
 * This file should import application root file.
 *
 * Execute all of module initialization.
 */
import { config } from '@/config'
import { getPlatformResult } from '@/core/native/app'
import { lockPortrait } from '@/core/native/screenOrientation'

import { init as initAtt } from '../core/appTrackingTransparency'
import { i18n, init as initI18n } from '../core/i18n/init'
import { init as initPayment } from '../core/payment'
import { init as initDayjs } from '../lib/dayjs'
import { init as initFirebase } from '../lib/firebase'

initI18n()
initDayjs(i18n.language)
initFirebase({
  appId: config.firebase.appId,
  projectId: config.firebase.projectId,
  apiKey: config.firebase.apiKey,
  senderId: config.firebase.senderId,
  measurementId: config.firebase.measurementId,
})
initPayment(
  config.stripeApiKey,
  getPlatformResult({
    ios: config.revenueCatApiKey.ios,
    android: config.revenueCatApiKey.android,
    web: '',
  })
)
initAtt()
// ネイティブアプリの場合、起動時に画面を縦固定にする。
// 動画の全画面再生時のみ横向きを許可し、それ以外は縦固定を維持する。
// Android の MainActivity は android:screenOrientation="portrait" だが、
// @capacitor/screen-orientation の lock() はランタイムで setRequestedOrientation を呼びマニフェストを上書きできるため、
// 起動時の lockPortrait() は競合せず縦を再強制する（src/core/native/screenOrientation/index.ts 参照）。
// bootstrap はトップレベル実行のため await できない。失敗は lockPortrait 内部の catch で処理される。
void lockPortrait()
